import AddSchool from '@/common/pages/(private)/(dashboard)/benefits/childcare-voucher/add-school';

export default function Page() {
  return <AddSchool />;
}
